import React from 'react';
import { useTranslation } from 'react-i18next';

import { useModal } from 'Components/ModalContext';

import PaymentInformation from './PaymentInformation';

/** Opens Set up billing in the right-hand drawer, where you are. Every entry point
 *  uses it: the recordings meter, the banner, Preferences > Billing. */
export function useSetUpBilling() {
  const { t } = useTranslation();
  const { openModal, closeModal } = useModal();
  return () =>
    openModal(<PaymentInformation mode="setup" onClose={closeModal} />, {
      title: t('Set up billing'),
    });
}
